import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=2a4d495f&scoped=true&"
import script from "./Details.vue?vue&type=script&setup=true&lang=js&"
export * from "./Details.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d495f",
  null
  
)

export default component.exports